import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getDiagramTourSteps({
	defaultStyles,
	isEdit,
}: ComponentTourProps & { isEdit: boolean }): AdvancedTourStep[] {
	if (isEdit) {
		return [
			{
				id: 'task-diagram',
				selector: '[data-tour="task-diagram"]',
				content:
					'This is your diagram view, this is where you will be able to setup a flow by dragging individual tasks and configuring them based on your needs.',
			},
			{
				id: 'task-selection',
				selector: '[data-tour="task-selection"]',
				content: 'These are all predetermined task for selection',
			},
			{
				id: 'individual-task',
				selector: '[data-tour="individual-task"]',
				content:
					'These are individual tasks, begin by dragging the "Set Variable" task to the diagram view to progress with the tutorial.',
				stepInteraction: true,
			},
		].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
	}

	return [
		{
			id: 'task-diagram',
			selector: '[data-tour="task-diagram"]',
			content: 'An interactive diagram used to display a "Flow setup".',
		},
		{
			id: 'task-search',
			selector: '[data-tour="task-search"]',
			content:
				'Search for tasks by name or by task type, to use the search you must enter a minimum of 3 characters.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
